module.exports = __webpack_public_path__ + "img/menu_lk.19877f38.svg";